<template>
    <div>
        <div class="page-head">
            <a-icon @click="$router.go(-1)" type="left-square" theme="filled"/>
            <a-breadcrumb>
                <a-breadcrumb-item>首页</a-breadcrumb-item>
                <a-breadcrumb-item><a href="javascript:;">销售工具</a></a-breadcrumb-item>
                <a-breadcrumb-item><a href="javascript:;">短信</a></a-breadcrumb-item>
            </a-breadcrumb>
        </div>

        <div class="callcenter">
            <!-- <div class="top-search record-search">
                <a-row type="flex">
                    <a-col><label for="">通话时间：</label></a-col>
                    <a-col>
                        <div class="select-date-custom">
                            <a-input class="search-date" v-model="time" @click="showdate">
                                <a-tooltip slot="suffix" @click="showdate">
                                    <div class="date-icon"></div>
                                </a-tooltip>
                            </a-input>
                            <span class="select-date-modal" v-if="dateshow">
                                <div class="date-modal">
                                    <div class="time-modal">
                                        <div class="time-system">
                                            <div class="select-item" @click="selectdate(i,item)" :class="{clickdate:i==currentdate}" v-for="(item,i) in datelist" :key="i">{{item}}</div>
                                        </div>
                                        <div class="time-custom">
                                            <span class="time-system-text">自定义</span>
                                            <div class="time-select-index-hide">
                                                <a-range-picker format="YYYY-MM-DD" @change="dateChange"/>
                                            </div>
                                            
                                        </div>
                                    </div>
                                </div>
                            </span>
                        </div>
                        
                    </a-col>
                </a-row>

                <a-row  type="flex">
                    <a-col><label for="">部门/员工：</label></a-col>
                    <a-col>
                        <a-select mode="multiple" style="width: 120px" @change="yghandleChange">
                            <a-select-option v-for="item in userlist" :key="item.id" value="item.id">{{item.name}}</a-select-option>
                        </a-select>
                    </a-col>
                </a-row>

                <a-row  type="flex">
                    <a-col><label for="">通话类型：</label></a-col>
                    <a-col>
                        <a-select style="width: 120px" @change="lxhandleChange">
                            <a-select-option value="线索">
                                线索
                            </a-select-option>
                            <a-select-option value="客户">
                                客户
                            </a-select-option>
                            <a-select-option value="商机">
                                商机
                            </a-select-option>
                            <a-select-option value="直呼">
                                直呼
                            </a-select-option>
                            <a-select-option value="回呼">
                                回呼
                            </a-select-option>
                        </a-select>
                    </a-col>
                </a-row>

                <a-row  type="flex">
                    <a-col><label for="">通话时长：</label></a-col>
                    <a-col>
                        <a-input style="width:80px" v-model="star" ></a-input> ~ <a-input v-model="end" style="width:80px"></a-input>
                    </a-col>
                </a-row>

                <a-row  type="flex">
                    <a-col><label for="">通话方式：</label></a-col>
                    <a-col>
                        <a-select style="width: 120px" @change="fshandleChange">
                            <a-select-option v-for="(item,i) in calllist" :key="i" :value="i">
                                {{item}}
                            </a-select-option>
                        </a-select>
                    </a-col>
                </a-row>

        
            </div> -->

            <div class="table-content">
                <div class="table-top-info" style="margin-top:0;display:flex;">
                    <!-- justify-content: space-between -->
                    <a-button @click="openAdd" type="primary">添加</a-button>
                    <a-button @click="openAll" type="danger">删除</a-button>
                    <div>
                        
                        <a-input-search
                        placeholder="请输入"
                        enter-button="搜索"
                        v-model="search"
                        @search="onSearch"
                        />
                    </div>
                </div>

                <a-spin :spinning="tablespinning">
                    <a-table :pagination="pageshow" :scroll="{ y: tabley}" :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }" :style="{height:tabley+'px'}" rowKey="id" :columns="columns" :data-source="data">

                        
                        <img class="list-img" slot="img" slot-scope="text" v-if="text" :src="text" alt="">
                        <span v-else> -- </span>
                        <span  slot="date" slot-scope="text" v-if="text=='1970-01-01 08:00:00'">--</span>
                        <span v-else>{{text}}</span>
                        <template slot="operation" slot-scope="text, record">
                            <a href="javascript:;" @click="openEdit(record.id)">编辑</a>
                            <a href="javascript:;" @click="delmodal(record.id)">删除</a>
                            <a href="javascript:;" @click="getUrl(record.id)">生成链接</a>
                        </template>
                    </a-table>

                    <div style="padding-top:30px;width: auto;display: flex;align-items: center;justify-content: flex-start;margin: 15px 12px 12px;">
                        <div class="page-total">总计：{{pagination.total}}条 / {{totalpage}}页</div>
                        <a-pagination
                        show-size-changer
                        :page-size-options="pageSizeOptions"
                        :default-current="1"
                        :total="pagination.total"
                        :defaultPageSize="10"
                        @change="handleTableChange"
                        @showSizeChange="onShowSizeChange"
                        >
                            <template slot="buildOptionText" slot-scope="props">
                                <span>{{ props.value }}条/页</span>
                            </template>

                        </a-pagination>
                    </div>
                </a-spin>
            </div>
        </div>

         <!-- 删除 -->
        <a-modal
        title="确认提示"
        :visible="delvisible"
        @ok="delhandleOk"
        @cancel="handleCancel"
        width="420px"
        okText="确定"
        >
            <div class="delLog">
               <div>
                   <img src="../../../static/tip.png" alt="">
               </div>
               <div>是否确定删除对应的数据?</div>
            </div> 
        </a-modal>

        <!-- 添加/编辑 -->
        <a-modal
        :title="wxtitle"
        :visible="textvisible"
        width="30%"
        cancelText="取消"
        okText="确定"
        @ok="handleOk"
        @cancel="handleCancel"
        >
           <div>
            <a-form :label-col="{ span: 4 }" :wrapper-col="{ span: 18 }">
                <a-form-item label="标题"> 
                    <a-input v-model="title" placeholder="请输入标题"/>
                </a-form-item>
                 <!-- {{file}} -->
                <a-form-item label="图片"> 
                    <a-upload
                        name="avatar"
                        list-type="picture-card"
                        class="avatar-uploader"
                        :headers="headers"
                        :show-upload-list="false"
                       
                        action="/api/upload"
                        @change="handleChange"
                    >
                   
                        <img class="ylimg" v-if="file" :src="file" alt="avatar" />
                        <div v-else>
                        <a-icon type="plus" />
                        <div class="ant-upload-text">
                            点击上传
                        </div>
                        </div>
                    </a-upload>
                </a-form-item>

            </a-form>
           </div>
        </a-modal>
    </div>
</template>
<style>
    .ant-tabs-top-content{margin-top:0 !important;}
    .avatar-uploader > .ant-upload {
    width: 128px;
    height: 128px;
    }
    .ant-upload-select-picture-card i {
    font-size: 32px;
    color: #999;
    }

    .ant-upload-select-picture-card .ant-upload-text {
    margin-top: 8px;
    color: #666;
    }
    .list-img{width:60px}
    .ylimg{width:160px}
</style>
<script>
const rowSelection = {
  onChange: (selectedRowKeys, selectedRows) => {
    console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
  },
  onSelect: (record, selected, selectedRows) => {
    console.log(record, selected, selectedRows);
  },
  onSelectAll: (selected, selectedRows, changeRows) => {
    console.log(selected, selectedRows, changeRows);
  },
};
const columns = [
    {
    title: 'ID',
    dataIndex: 'id',
    key: 'id',
    width:"90px"
  },
  {
    title: '名称',
    dataIndex: 'title',
    key: 'title',
  },
  {
    title: '图片',
    dataIndex: 'src_fx',
    key: 'src_fx',
    scopedSlots: { customRender: 'img' },
  },
   {
    title: 'URL Scheme',
    dataIndex: 'generatescheme',
    key: 'generatescheme',
  },
  {
    title: '创建时间',
    dataIndex: 'generatescheme_starttime',
    key: 'generatescheme_starttime',
    scopedSlots: { customRender: 'date' },
  },
  {
    title: '过期时间',
    dataIndex: 'generatescheme_endtime',
    key: 'generatescheme_endtime',
    scopedSlots: { customRender: 'date' },
  },
    {
        title: '操作',
        dataIndex: 'operation',
        scopedSlots: { customRender: 'operation' },
    },
];

export default {
    data(){
        return{
            columns,
            data:[],
            btnsize:'',
            rowSelection,
            pagination:{},
            size:10,
            currentpage:"",
            pageshow:false,
            totalpage:"",
            windowHeight: document.documentElement.clientHeight,   //实时屏幕高度
            tabley:"",
            tablespinning:true,
            selectedRowKeys:[],
            statistic:"",
            arrow:false,


            exportvisible:false,
            confirmLoading:false,
            spinning:true,

            textvisible:false,

            type:"",
            time:"",
            callrang:"",
            belong:[],
            method:"",
            datelist:['今天','昨天','本周','上周','本月','上月'],
            datelist2:['今天','昨天'],
            currentdate:"",
            calllist:"",
            star:"",
            end:"",
            dateshow:false,
            userlist:"",


            delvisible:false,
            search:"",
            title:"",
            file:"",
            wxtitle:"添加",
            headers:{
                "appid": this.appSet.appid,
                "appkey": this.appSet.appkey,
                "token":localStorage.getItem('token'),

            },
            delid:"",
            editid:""

        }
    },
    watch: {
      windowHeight (val) {
        this.tabley=val*0.56
      },
    },
    mounted(){

        this.fetch()
       
        window.fullHeight = document.documentElement.clientHeight;
        this.windowHeight = window.fullHeight;  
        this.tabley=this.windowHeight*0.56
         // <!--把window.onresize事件挂在到mounted函数上-->
        window.onresize = () => {
            return (() => {
                window.fullHeight = document.documentElement.clientHeight;
                this.windowHeight = window.fullHeight;  // 高
                this.tabley=this.windowHeight*0.56
                console.log("实时屏幕高度：",this.tabley);
            })()
        };

     
        // this.setAudioInterval();
    },
    methods:{

        // 生成链接
        getUrl(id){
            this.$axios.post("/api/generatescheme",{
                'id':id
            },{
                headers: {
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                    "token":localStorage.getItem('token'),
                },
            }).then((res)=>{
                if(res.data.errcode==0){
                    this.$message.success("生成成功"); 
                    this.fetch()
                }else{
                    this.$message.error(res.data.errmsg); 
                }
            })
        },

        // 上传图片
        handleChange(res){
            // console.log(file)
            console.log(res)
            this.file=res.file.response.url
        },
        openAll(){
            var id=this.selectedRowKeys.join(",")
            this.delid=id
            this.delvisible=true
        },

        delmodal(id){
            this.delid=id
            this.delvisible=true
        },
        delhandleOk(){
            // if(this.delid!=""){
            //     this.selectedRowKeys.push(this.delid)
            // }
            var id=this.delid
            this.$axios.post("/api/delwxfx",{
                'ids':id
            },{
                headers: {
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                    "token":localStorage.getItem('token'),
                },
            }).then((res)=>{
                if(res.data.code==200){
                    this.delvisible=false
                    this.$message.success(res.data.msg); 
                    this.fetch()
                }else{
                    this.$message.error(res.data.msg); 
                }
            })
        },

        // 添加、编辑
        openEdit(id){
            
            this.wxtitle="编辑"
            this.editid=id
            this.$axios.post('/api/wxfxpage',{
                id:id
            },{
                headers: {
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.status==1){
                    this.textvisible=true
                    this.title=res.data.title
                    this.file=res.data.src_fx
                }else if(res.data.code==300){
                    this.$router.push({path: '/'})
                }else if(res.data.code==401){
                    this.$message.warning(res.data.msg); 
                }else{
                    this.$message.warning(res.data.msg); 
                }
            })
        },


        openAdd(){
            this.textvisible=true
            this.wxtitle="添加"
            this.title=""
            this.file=""
        },
        handleOk(){
            if(this.wxtitle=="添加"){
                this.$axios.post('/api/addwxfx',{
                    title: this.title,
                    src_fx:this.file
                },{
                    headers: {
                        "appid": this.appSet.appid,
                        "appkey": this.appSet.appkey,
                        "token":localStorage.getItem('token'),
                    }
                }).then((res)=>{
                    if(res.data.code==200){
                        this.textvisible=false
                        this.$message.success("添加成功"); 
                        this.fetch()
                    }else if(res.data.code==300){
                        this.$router.push({path: '/'})
                    }else if(res.data.code==401){
                        this.$message.warning(res.data.msg); 
                    }else{
                        this.$message.warning(res.data.msg); 
                    }
                })
            }else if(this.wxtitle=="编辑"){
                this.$axios.post('/api/updatewxfx',{
                    id:this.editid,
                    title: this.title,
                    src_fx:this.file
                },{
                    headers: {
                        "appid": this.appSet.appid,
                        "appkey": this.appSet.appkey,
                        "token":localStorage.getItem('token'),
                    }
                }).then((res)=>{
                    if(res.data.code==200){
                        
                        this.textvisible=false
                        this.$message.success("编辑成功"); 
                        this.fetch()
                    }else if(res.data.code==300){
                        this.$router.push({path: '/'})
                    }else if(res.data.code==401){
                        this.$message.warning(res.data.msg); 
                    }else{
                        this.$message.warning(res.data.msg); 
                    }
                })
            }
        },

        onSearch(){

        },

        handleCancel(){
            this.delvisible=false
            this.textvisible=false
        },

        // 复选框选择
        onSelectChange(selectedRowKeys) {
            console.log('selectedRowKeys changed: ', selectedRowKeys);
            this.selectedRowKeys = selectedRowKeys;
        },
        
        onShowSizeChange(current,pageSize){
            this.size=pageSize
            // alert(pageSize)
            this.fetch();
        },
        handleTableChange(pageNumber) {
            this.currentpage=pageNumber
            this.fetch();
        },
        fetch(params = {}) {
            this.loading = true;
            this.$axios.post('/api/wxfxlist',{
                    search:this.search,
                    pagesize: this.size,
                    page:this.currentpage
                    
                },{
                headers: {
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.tablespinning=false
                    const pagination = { ...this.pagination };
                    pagination.total = res.data.data.allcount;
                    pagination.pageSize=this.size
                    this.data=res.data.data.lists
                    this.pagination = pagination;
                    this.totalpage=Math.ceil(res.data.data.allcount/this.size)
                }else if(res.data.code==300){
                    this.$router.push({path: '/'})
                }else if(res.data.code==401){
                    this.$message.warning(res.data.msg); 
                }else{
                    this.$message.warning(res.data.msg); 
                }
            })
        },
    }
}
</script>



// WEBPACK FOOTER //
// src/components/wxshare/wxshare.vue